import React, {useState,useEffect} from 'react';
import { Row, Col, Button, Label, Input } from 'reactstrap';
import TendinaOrariAStep from '../Pagine/TendinaOrariAStep.js';
import Modale from './Modale.js';

import Cestino from "../immagini/cestino.png"

function TabellaOrariIndisponibilita(props) {
    
    const [orariIndisponibilita,setOrariIndisponibilita]=useState([]);
    const [flagModaleIntervallo, setFlagModaleIntervallo]=useState(false);
    
    const [dalGiorno, setDalGiorno] = useState('');
    const [alGiorno, setAlGiorno] = useState('');
    const [dalleOre, setDalleOre] = useState('');
    const [alleOre, setAlleOre] = useState('');

    const giorniSettimana = [
        { indice: 1, nome: "Lunedì" },
        { indice: 2, nome: "Martedì" },
        { indice: 3, nome: "Mercoledì" },
        { indice: 4, nome: "Giovedì" },
        { indice: 5, nome: "Venerdì" },
        { indice: 6, nome: "Sabato" },
        { indice: 0, nome: "Domenica" },
    ];

    const [giorniSelezionati, setGiorniSelezionati] = useState([1,2,3,4,5,6,0]);
    
    const intervalloTendina=5;
    
    useEffect(() => {
        if(props.orariIndisponibilita !== undefined) {
            setOrariIndisponibilita(props.orariIndisponibilita);
        }
    },[])

    function handleCambiamentoMod() {
        props.callbackSetVariazioneCampi(1);
    }

    function callbackSetVariazioneCampiOrari(){        
        props.callbackSetVariazioneCampi(1);
    }

    function callbacksetOrarioSelezionatoInizio(valore,props2){
        let orari = [...orariIndisponibilita];
        orari[props2.indice].inizio=valore;
        setOrariIndisponibilita(orari);
        props.callbackSetOrariIndisponibilita(orari);
    }

    function callbacksetOrarioSelezionatoFine(valore,props2){
        let orari = [...orariIndisponibilita];
        orari[props2.indice].fine=valore;
        setOrariIndisponibilita(orari);
        props.callbackSetOrariIndisponibilita(orari);
    }

    function aggiornaData(index,dato){       
        let orari = [...orariIndisponibilita];
        orari[index].data=dato;
        setOrariIndisponibilita(orari);
        props.callbackSetOrariIndisponibilita(orari);
    }
         
    function aggiungiOrario(props) {
        let orari = [...orariIndisponibilita];
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');        

        orari.push({
            data: year+"-"+month+"-"+day,
            inizio: "12:00",
            fine: "12:00"
        });

        setOrariIndisponibilita(orari);
        props.callbackSetOrariIndisponibilita(orari);
    }

    function eliminaOrario(posizione) {
        let orari = [...orariIndisponibilita];
        orari.splice(posizione, 1);
        setOrariIndisponibilita(orari);
        props.callbackSetOrariIndisponibilita(orari);
    }

    function cambiaGiornoSelezionato(indiceGiorno) {
        let nuoviGiorni = [...giorniSelezionati];

        if (nuoviGiorni.includes(indiceGiorno)) {
            nuoviGiorni = nuoviGiorni.filter(g => g !== indiceGiorno);
        } else {
            nuoviGiorni.push(indiceGiorno);
        }

        setGiorniSelezionati(nuoviGiorni);
    }

    function aggiungiIntervalloDate() {
        if (!dalGiorno || !alGiorno || !dalleOre || !alleOre) {
            window.alert("Verifica di aver inserito le date e gli orari");
            return;
        }

        if (giorniSelezionati.length === 0) {
            window.alert("Seleziona almeno un giorno della settimana");
            return;
        }

        if (dalGiorno > alGiorno) {
            window.alert("La data iniziale non può essere successiva a quella finale");
            return;
        }

        if (dalGiorno === alGiorno && dalleOre >= alleOre) {
            window.alert("L'orario iniziale deve essere precedente all'orario finale");
            return;
        }

        const nuoveDate = [];
        let dataCorrente = new Date(dalGiorno);

        while (dataCorrente <= new Date(alGiorno)) {
            const giornoSettimana = dataCorrente.getDay();

            if (giorniSelezionati.includes(giornoSettimana)) {
                const dataString = dataCorrente.toISOString().split("T")[0];

                nuoveDate.push({
                    data: dataString,
                    inizio: dalleOre,
                    fine: alleOre,
                });
            }

            dataCorrente.setDate(dataCorrente.getDate() + 1);
        }

        const esisteGia = (item) =>
            orariIndisponibilita.some(
                e => e.data === item.data && e.inizio === item.inizio && e.fine === item.fine
            );

        const nuoviUnici = nuoveDate.filter(item => !esisteGia(item));
        const nuovoArray = [...orariIndisponibilita, ...nuoviUnici];

        setOrariIndisponibilita(nuovoArray);
        props.callbackSetOrariIndisponibilita(nuovoArray);
        props.callbackSetVariazioneCampi(1);

        setFlagModaleIntervallo(false);
    }

    return (        
        <div>     

            {flagModaleIntervallo &&
                <Modale 
                    titolo="Aggiungi un intervallo di date di indisponibilità"
                    flagErrore={false}
                    contenuto={
                        <div>
                            <div>
                                Dal giorno&nbsp;
                                <input 
                                    type="date" 
                                    value={dalGiorno} 
                                    onChange={(e) => setDalGiorno(e.target.value)} 
                                />
                            </div>

                            <br/>

                            <div>
                                Al giorno&nbsp;
                                <input 
                                    type="date" 
                                    value={alGiorno} 
                                    onChange={(e) => setAlGiorno(e.target.value)} 
                                />
                            </div>

                            <br/>

                            <div>
                                Dalle ore&nbsp;
                                <input 
                                    type="time" 
                                    value={dalleOre} 
                                    onChange={(e) => setDalleOre(e.target.value)} 
                                />
                                &nbsp;alle ore&nbsp;
                                <input 
                                    type="time" 
                                    value={alleOre} 
                                    onChange={(e) => setAlleOre(e.target.value)} 
                                />
                            </div>

                            <br/>

                            <div>
                                <div style={{marginBottom: 5}}>
                                    Giorni della settimana
                                </div>

                                {giorniSettimana.map((giorno) =>
                                    <label 
                                        key={giorno.indice} 
                                        style={{display: "inline-block", marginRight: 15, marginBottom: 8}}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={giorniSelezionati.includes(giorno.indice)}
                                            onChange={() => cambiaGiornoSelezionato(giorno.indice)}
                                        />
                                        &nbsp;{giorno.nome}
                                    </label>
                                )}
                            </div>
                        </div>
                    }
                    bottoni={[
                        {
                            etichetta: "OK",
                            tipo: "primary",
                            callback: aggiungiIntervalloDate
                        },
                        {
                            etichetta: "Annulla",
                            tipo: "primary",
                            callback: () => { setFlagModaleIntervallo(false); }
                        },
                    ]}
                />
            }

            <Row>
                <Col md="12">
                    {orariIndisponibilita.map((elemento,index) => 
                        <div style={{display:"flex", flexDirection:"row"}} key={index}>
                            
                            <div style={{minWidth: 40,paddingRight:10,paddingTop:30}}>
                                <img 
                                    onClick={() => {
                                        props.callbackSetVariazioneCampi(1);
                                        eliminaOrario(index);
                                    }} 
                                    src={Cestino}
                                />
                            </div>
        
                            <div style={{minWidth: 100,paddingRight:10}}>
                                <Label for="giorno">Data&nbsp;</Label><br/>   
                                <Input 
                                    type="date" 
                                    value={elemento.data}
                                    style={{width: 'auto',height: 36,borderRadius: '5px 5px 5px 5px'}} 
                                    onInput={(e)=>{
                                        handleCambiamentoMod(e);
                                        aggiornaData(index,e.target.value);
                                    }}
                                />
                            </div>
                                                        
                            <div style={{minWidth: 100,paddingRight:10}}>
                                <Label for="orarioInizio">Orario Inizio&nbsp;</Label>
                                    
                                <TendinaOrariAStep
                                    step={intervalloTendina}
                                    orarioDefault={elemento.inizio}
                                    orarioInizio="00:00"
                                    orarioFine="24:00"
                                    indice={index}
                                    callbackSetVariazioneCampi={callbackSetVariazioneCampiOrari}
                                    callbacksetOrarioSelezionato={callbacksetOrarioSelezionatoInizio}
                                />
                            </div>
                            
                            <div style={{minWidth: 100,paddingRight:10}}>
                                <Label for="orarioFineDisponibilita">Orario Fine&nbsp;</Label>
                                <TendinaOrariAStep
                                    step={intervalloTendina}
                                    orarioDefault={elemento.fine}
                                    orarioInizio="00:00"
                                    orarioFine="24:00"
                                    indice={index}
                                    callbackSetVariazioneCampi={callbackSetVariazioneCampiOrari}
                                    callbacksetOrarioSelezionato={callbacksetOrarioSelezionatoFine}
                                />
                            </div>

                            <div style={{paddingRight:10}}>
                                <Label for="messaggioErrore">&nbsp;</Label><br/> 
                                {orariIndisponibilita[index].inizio >= orariIndisponibilita[index].fine && 
                                    <span style={{color:"#FF0000"}}>orari non validi</span>
                                }
                            </div>

                        </div>
                    )}

                    <Row>
                        <Col md={12}>
                            <Button 
                                color="primary" 
                                className="mt-2 bottoneMargineADestra" 
                                onClick={() => {
                                    props.callbackSetVariazioneCampi(1);
                                    aggiungiOrario(props);
                                }}
                            >
                                Aggiungi orario
                            </Button>

                            <Button 
                                color="primary" 
                                className="mt-2 bottoneMargineADestra" 
                                onClick={() => {
                                    props.callbackSetVariazioneCampi(1);
                                    setFlagModaleIntervallo(true);

                                    const oggi = new Date().toISOString().split('T')[0];

                                    setDalGiorno(oggi);
                                    setAlGiorno(oggi);
                                    setDalleOre("00:00");
                                    setAlleOre("23:00");

                                    // default: tutti i giorni selezionati
                                    setGiorniSelezionati([1,2,3,4,5,6,0]);
                                }}
                            >
                                Aggiungi intervallo di date
                            </Button>                              
                        </Col>
                    </Row>
                        
                </Col>   
            </Row>
        </div>
    );
}

export default TabellaOrariIndisponibilita;
